import {
    IHoneybookAI,
    ITaskRepository,
    IActionManager
} from '../types/public-types';
import {
    IHttpClient,
    ILogger,
    IStreamingProviderFactory,
    IAppLifecycleProvider
} from '~/packages/core';
import { TaskRepository } from './task-repository';
import { AITaskService } from './ai-task.service';
import { ActionManager } from './action-manager';
import { AiPromptsLibraryService } from './ai-prompts-library.service';
import { IStorage } from '~/packages/core';

export interface HoneybookAIOptions {
    httpClient: IHttpClient;
    streamingProviderFactory: IStreamingProviderFactory;
    logger: ILogger;
    storage: IStorage;
    appLifecycleProvider: IAppLifecycleProvider;
}

export class HoneybookAI implements IHoneybookAI {
    private readonly taskRepository: ITaskRepository;
    private readonly httpClient: IHttpClient;
    private readonly streamingProviderFactory: IStreamingProviderFactory;
    private readonly actionManager: ActionManager;
    private readonly logger: ILogger;
    private readonly aiPromptsLibraryService: AiPromptsLibraryService;

    constructor({
        httpClient,
        streamingProviderFactory,
        logger,
        storage,
        appLifecycleProvider
    }: HoneybookAIOptions) {
        this.httpClient = httpClient;
        this.streamingProviderFactory = streamingProviderFactory;
        this.logger = logger;
        this.actionManager = new ActionManager(this.logger);
        this.aiPromptsLibraryService = new AiPromptsLibraryService(
            this.httpClient
        );

        // Initialize task client with optional base URL
        const taskClient = new AITaskService(httpClient);

        // Create task repository with client, transport factory, and storage
        this.taskRepository = new TaskRepository({
            taskClient,
            streamingProviderFactory,
            actionManager: this.actionManager,
            logger: this.logger,
            storage: storage,
            appLifecycleProvider
        });
    }

    getTaskRepository(): ITaskRepository {
        return this.taskRepository;
    }

    getActionManager(): IActionManager {
        return this.actionManager;
    }

    getAiPromptsLibraryService(): AiPromptsLibraryService {
        return this.aiPromptsLibraryService;
    }
}
